import { computed, onMounted, ref } from 'vue'
import { getWebsiteSettings, type WebsiteSettings } from '@/api/website'

const webAppPath = '/app/auth'
const maxLoadAttempts = 3
const retryDelayMs = 1_500

const fallbackSettings = (): WebsiteSettings => ({
  iosAppUrl: '',
  androidAppUrl: '',
  iosDownloadQrUrl: '',
  androidDownloadQrUrl: '',
  miniProgramQrUrl: '',
  copyrightOwner: '麦汁实验室',
  icpRecordNumber: '',
  icpRecordUrl: '',
  publicSecurityRecordNumber: '',
  publicSecurityRecordUrl: '',
  publicSecurityIconUrl: '',
  logoUrl: '',
  inverseLogoUrl: '',
  heroImageUrl: '',
  storyOneImageUrl: '',
  storyTwoImageUrl: '',
  storyThreeImageUrl: '',
  subjectPhysicsImageUrl: '',
  subjectChemistryImageUrl: '',
  subjectBiologyImageUrl: '',
  subjectScienceImageUrl: '',
  sceneStudentImageUrl: '',
  sceneClassroomImageUrl: '',
})

const settings = ref<WebsiteSettings>(fallbackSettings())
let loadPromise: Promise<void> | undefined
let retryTimer: number | undefined

function clearRetryTimer() {
  if (retryTimer === undefined) return
  window.clearTimeout(retryTimer)
  retryTimer = undefined
}

function load(attempt = 1) {
  if (!loadPromise) {
    loadPromise = getWebsiteSettings()
      .then((value) => {
        clearRetryTimer()
        settings.value = { ...settings.value, ...value }
      })
      .catch(() => {
        if (attempt >= maxLoadAttempts || retryTimer !== undefined) return
        retryTimer = window.setTimeout(() => {
          retryTimer = undefined
          void load(attempt + 1)
        }, retryDelayMs)
      })
      .finally(() => {
        loadPromise = undefined
      })
  }
  return loadPromise
}

export function useWebsiteSettings(enabled = true) {
  onMounted(() => {
    if (enabled) void load()
  })
  return {
    settings,
    webUrl: computed(() => webAppPath),
    iosUrl: computed(() => settings.value.iosAppUrl),
    androidUrl: computed(() => settings.value.androidAppUrl),
    reload: load,
  }
}
